export type ColumnConfiguration = {
  width?: number;
  index: number;
};

export type TableContextType = {
  columnsConfiguration: ColumnConfiguration[];
};

export const DEFAULT_TABLE_CONTEXT: TableContextType = {
  columnsConfiguration: [],
};
